<template>
  <v-container fluid fill-height style="border: 1px solid #e2e2e2; background-color: #f2f2f2">
    <!-- Header -->
    <v-row style="max-width: 1800px">
      <v-col class="ml-4">
        <v-img height="50" width="120" class="avlLogo" src="@/assets/images/sigfloLogoTempDark.png" />
      </v-col>
      <v-col class="text-center">
        <span class="text-h4">Checkout</span>
      </v-col>
      <v-col class="text-right mr-2"> </v-col>
    </v-row>
    <!-- Panels -->
    <v-container fluid class="d-flex mx-10" style="max-width: 1800px">
      <v-row>
        <v-col cols="8">
          <product-summary-panel
            v-show="currentPanel == panels.PRODUCT_SUMMARY"
            :project="project"
            :disabled="loadingProject"
            @next-step="nextStep"
          ></product-summary-panel>
          <stripe-panel @previous-step="previousStep" v-show="currentPanel == panels.STRIPE"></stripe-panel>
        </v-col>
        <!-- Product Summary-->
        <v-col class="mr-6">
          <v-card
            max-width="550"
            class="sigfloCard sigfloNeutralBorder150 elevation-0"
            :loading="loadingProject"
            :disabled="loadingProject"
            flat
          >
            <v-card-title class="font-weight-thin text-h5 black--text">Project Summary</v-card-title>
            <v-card-text>
              <v-divider />
              <v-row>
                <v-col class="text-uppercase">Subtotal</v-col>
                <v-col class="">${{ project ? formatPrice(project.subtotal) : '-' }}</v-col>
              </v-row>
              <v-row v-if="project && project.discount && project.discount > 0">
                <v-col class="text-uppercase">Discount ({{ project.discountCode }})</v-col>
                <v-col class="">${{ project ? formatPrice(project.discount) : '-' }}</v-col>
              </v-row>
              <v-row>
                <v-col class="text-uppercase">Taxes</v-col>
                <v-col class="" v-show="checkout.taxTotal == 0">$ -</v-col>
                <v-col class="" v-show="checkout.taxTotal > 0">$ {{ checkout.taxTotal }}</v-col>
              </v-row>
              <v-row>
                <v-col class="text-uppercase">Shipping*</v-col>
                <v-col class="">FREE</v-col>
              </v-row>
              <v-divider />
              <v-row>
                <v-col class="black--text">Total</v-col>
                <v-col class="black--text">${{ project ? formatPrice(project.sellPrice) : '-' }}</v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <div class="mx-4 text-center mt-1 grey--text text-caption">
            <i
              >*Sigflō offers free ground shipping, with orders usually arriving in<br />
              5-7 business days</i
            >
          </div>
          <div>
            <v-row class="justify-center mt-4">
              <v-col cols="8" class="d-flex align-center">
                <v-text-field
                  v-model="discountCode"
                  label="Discount Code"
                  outlined
                  dense
                  class="mr-2"
                  :messages="discountMessage"
                ></v-text-field>
                <v-btn class="mb-6" dark color="#7C40DC" rounded @click="applyDiscount">Apply</v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
  import ProductSummaryPanel from '@/components/checkout/ProductSummaryPanel.vue';
  import StripePanel from '@/components/checkout/StripePanel.vue';

  import { mapState } from 'vuex';
  import Vue from 'vue';

  export default {
    components: {
      ProductSummaryPanel,
      StripePanel
    },
    data() {
      return {
        project: null,
        currentPanel: 0,
        loadingProject: false,
        discountMessage: null,
        discountApplied: false,
        discountCode: null,
        panels: {
          PRODUCT_SUMMARY: 0,
          STRIPE: 1,
          SHIPPING: 2,
          PAYMENT: 3
        }
      };
    },
    mounted() {
      if (!this.configurator.currentProject) {
        this.navToProjectPage();
        return;
      }
      this.loadPage();
    },
    computed: {
      ...mapState(['app', 'configurator', 'checkout']),
      cartTotal() {
        const projectTotal = this.project ? this.project.sellPrice : 0;
        const shippingTotal = this.checkout.shippingTotal;
        const taxTotal = this.checkout.taxTotal;
        const discount = this.project ? this.project.discount : 0;
        return projectTotal - discount + shippingTotal + taxTotal;
      }
    },
    methods: {
      loadPage() {
        this.loadingProject = true;
        this.$store.commit('configurator/setCurrentProjectLoading', true);
        this.$store
          .dispatch('configurator/getProject', {
            projectId: this.configurator.currentProject.id,
            returnData: true
          })
          .then((project) => {
            this.$store.commit('configurator/setCurrentProjectLoading', false);
            this.project = project;
            this.$store
              .dispatch('configurator/getSystemsForCheckout', {
                projectId: project.id
              })
              .then((systems) => {
                Vue.set(this.project, 'systems', systems);
                this.loadingProject = false;
                systems.forEach((system) => {
                  this.$store
                    .dispatch('configurator/getSubsystems', {
                      systemId: system.id,
                      returnData: true
                    })
                    .then((subsystems) => {
                      Vue.set(system, 'subsystems', subsystems);
                    });
                });
              });
          });
      },
      applyDiscount() {
        this.project.discountCode = this.discountCode;
        this.$store.dispatch('configurator/applyDiscount', this.project).then((response) => {
          if (response && response.sigMessageModel) {
            this.discountMessage = response.sigMessageModel.message;
            this.loadPage();
          }
        });
      },
      nextStep() {
        if (this.currentPanel + 1 > 0) {
          if (this.app.user.isGuest) {
            this.$store.commit('app/setShowCreateAccountDialog', true);
            return;
          }
        }
        this.currentPanel += 1;
      },
      previousStep() {
        this.currentPanel -= 1;
      }
    }
  };
</script>

<style scoped>
  .white {
    background-color: white;
  }
  .text-right {
    justify-content: flex-end !important;
  }
</style>
